import { NgModule } from "@angular/core";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";

@NgModule({
  exports: [NgxMaterialTimepickerModule],
  declarations: [],
  imports: [NgxMaterialTimepickerModule],
})
export class NgxTimpickerModule {}
